(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialize = (section) => {
    if (section.dataset.hitchCampaignInitialized === 'true') return;
    section.dataset.hitchCampaignInitialized = 'true';

    const wrappers = Array.from(section.querySelectorAll('[data-hitch-campaign-video-wrapper]'));
    const control = section.querySelector('[data-hitch-campaign-video-control]');
    const autoplay = section.dataset.autoplay === 'true';
    const pauseWhenHidden = section.dataset.pauseWhenHidden === 'true';
    let activeVideo;
    let isVisible = true;
    let userPaused = !autoplay;

    const getActiveVideo = () => {
      const deviceClass = mobileQuery.matches
        ? 'hitch-campaign-media__video-wrapper--mobile'
        : 'hitch-campaign-media__video-wrapper--desktop';
      return wrappers.find((wrapper) => wrapper.classList.contains(deviceClass))?.querySelector('video');
    };

    const updateControl = () => {
      if (!control) return;
      control.hidden = !activeVideo;
      if (!activeVideo) return;
      const isPlaying = !activeVideo.paused && !activeVideo.ended;
      control.dataset.state = isPlaying ? 'playing' : 'paused';
      control.setAttribute('aria-label', isPlaying ? control.dataset.pauseLabel : control.dataset.playLabel);
    };

    const pause = (video) => {
      if (video && !video.paused) video.pause();
    };

    const play = (userInitiated = false) => {
      if (!activeVideo || userPaused || !isVisible || document.hidden || (reducedMotionQuery.matches && !userInitiated)) {
        updateControl();
        return;
      }
      if (activeVideo.preload === 'none') {
        activeVideo.preload = 'metadata';
        activeVideo.load();
      }
      activeVideo.muted = true;
      activeVideo.playsInline = true;
      activeVideo.play().catch(updateControl);
    };

    const switchVideo = () => {
      const nextVideo = getActiveVideo();
      wrappers.forEach((wrapper) => {
        const video = wrapper.querySelector('video');
        if (video !== nextVideo) pause(video);
      });
      activeVideo = nextVideo;
      updateControl();
      play();
    };

    wrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      ['play', 'pause', 'ended', 'error'].forEach((eventName) => video.addEventListener(eventName, updateControl));
    });

    control?.addEventListener('click', () => {
      if (!activeVideo) return;
      if (activeVideo.paused || activeVideo.ended) {
        userPaused = false;
        isVisible = true;
        play(true);
      } else {
        userPaused = true;
        pause(activeVideo);
      }
    });

    mobileQuery.addEventListener('change', switchVideo);
    reducedMotionQuery.addEventListener('change', () => {
      if (reducedMotionQuery.matches) pause(activeVideo);
      else play();
      updateControl();
    });

    if (pauseWhenHidden && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        isVisible = entry.isIntersecting;
        if (isVisible) play();
        else pause(activeVideo);
        updateControl();
      }, { threshold: 0.1 }).observe(section);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pause(activeVideo);
      else play();
      updateControl();
    });

    switchVideo();
  };

  const initializeAll = (root = document) => root.querySelectorAll('[data-hitch-campaign-media]').forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
